import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { ICreateVehicle, IUpdateVehicle } from './interfaces/vehicle.interface';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { VechicleService } from './vehicle.service';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { environment } from 'environments/environment.prod';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { VehicleTypeService } from '../type-vehicle/type-vehicle.service';
import { MatTabsModule } from '@angular/material/tabs';
import VehicleAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity';
import VehicleTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { VehicleExport } from './exports/vechicle.export';
import { VEHICLE_TITLE } from './exports/vechicle.constants';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { BusinessPartnersFiltersComponent } from '../../filters/business-partners-filters/business-partners-filters.component';
import { RoutesDetailByBusinessPartnerVehicleComponent } from '../../modals/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle.component';
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';
import { UnitMeasureService } from '../../master/unit-of-measurement/unit-of-measurement.service';
import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import { UnitMeasurementGroupEnum } from '../../material/material-group-unit-measurement/material-group-unit.enum';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-vechicle',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterComponent,
    BusinessPartnersFiltersComponent,
    RoutesDetailByBusinessPartnerVehicleComponent,
    FormSectionComponent,
    BusinessPartnersFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    VehicleExport
  ],
  templateUrl: './vechicle.component.html',
  styleUrl: './vechicle.component.scss'
})
export class VechicleComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "name",
    "businessPartner",
    "ownership", //Specify property
    "type",
    "plate",
    "company",
    "statusId",
    "action"
  ];

  dataSource = new MatTableDataSource<VehicleAttributes>([]);

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof VehicleAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  businessPartnerList: BusinessPartnerAttributes[] = [];
  searchBusiness = ''
  private searchSubjectBusiness = new Subject<string>();

  reasonVehicleTypeList: VehicleTypeAttributes[] = [];
  filteredReasonVehicleTypeList: VehicleTypeAttributes[] = [];
  searchReasonVehicleType: string = '';

  //#region Unit Measurement
  UnitMeasurementGroupEnum = UnitMeasurementGroupEnum;

  unitMeasurementsByGroup: Record<UnitMeasurementGroupEnum, UnitMeasurementsAttributes[]> = {
    [UnitMeasurementGroupEnum.LENGTH]: [],
    [UnitMeasurementGroupEnum.MASS]: [],
    [UnitMeasurementGroupEnum.VOLUME]: []
  };

  searchByGroup: Record<UnitMeasurementGroupEnum, string> = {
    [UnitMeasurementGroupEnum.LENGTH]: '',
    [UnitMeasurementGroupEnum.MASS]: '',
    [UnitMeasurementGroupEnum.VOLUME]: ''
  };

  private searchSubjects: Record<UnitMeasurementGroupEnum, Subject<string>> = {
    [UnitMeasurementGroupEnum.LENGTH]: new Subject<string>(),
    [UnitMeasurementGroupEnum.MASS]: new Subject<string>(),
    [UnitMeasurementGroupEnum.VOLUME]: new Subject<string>()
  };
  //#endregion

  currentVechicle: ICreateVehicle = this.initializeCreateVehicle();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  dialogRef: MatDialogRef<any>;

  @ViewChild("routesModal") routesModal!: TemplateRef<any>;
  @ViewChild("tripsModal") tripsModal!: TemplateRef<any>;

  dialogRefRoutesDetail: MatDialogRef<any>;
  dialogRefTripsDetail: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  selectedStatuses: number[] = [];
  selectedStatusesBankType: string[] = [];

  vehicleIdSelected: string[] = [];

  // Lazy loading flags
  loadFiltersData = false;

  constructor(
    private vechicleService: VechicleService,
    private readonly vehicleTypeService: VehicleTypeService,
    private readonly companyService: CompanyService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly unitMeasureService: UnitMeasureService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public exportService: ExportService,
    private vehicleExport: VehicleExport,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [null],
      customerId: [null],
      vehicleTypeId: [null]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  onClearFilter() {
    // Resetear arrays de filtros de estado
    this.selectedStatuses = [];
    this.selectedStatusesBankType = [];

    // Resetear formulario con valores iniciales explícitos
    this.form.reset({
      companyId: null,
      customerId: null,
      vehicleTypeId: null
    });

    // Resetear paginación y búsqueda
    this.pageIndex = 1; // Vuelve a la primera página
    this.search = ''; // Limpiar búsqueda local

    // Recargar lista con filtros limpios
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  openRoutesModal(vehicle: VehicleAttributes): void {
    this.vehicleIdSelected = [];
    this.vehicleIdSelected.push(vehicle._id.toString());
    this.dialogRefRoutesDetail = this.dialog.open(this.routesModal, {
      disableClose: true,
      width: '1200px',
      maxHeight: '800px'
    });
    this.dialogRefRoutesDetail.afterClosed().subscribe((result) => {
      result
    });
  }

  openTripsModal(vehicle: VehicleAttributes): void {
    this.vehicleIdSelected = [];
    this.vehicleIdSelected.push(vehicle._id.toString());
    this.dialogRefTripsDetail = this.dialog.open(this.tripsModal, {
      disableClose: true,
      width: '1200px',
      maxHeight: '800px'
    });
    this.dialogRefTripsDetail.afterClosed().subscribe((result) => {
      result
    });
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let isOwn: boolean = false;

    let allStatus: boolean = true;

    if (this.selectedStatusesBankType.length === 0) {
      allStatus = false;
    } else {
      if (this.selectedStatusesBankType.length > 1) {
        allStatus = false;
      }
      if (this.selectedStatusesBankType[0] === "OWN") isOwn = true;
    }

    this.vechicleService.getAllPaginateVehicle(options,
      this.form.get("companyId").value,
      this.form.get("vehicleTypeId").value,
      this.form.get("customerId").value,
      this.selectedStatuses,
      isOwn,
      allStatus
    ).subscribe({
      next: (res: IPaginationResult<VehicleAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipos de pago", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateVehicle(): ICreateVehicle {
    return {
      code: "",
      externalKey: null,
      name: "",
      description: "",
      typeId: null,
      brand: null,
      plate: null,
      dimensionHeight: 0,
      dimensionWidth: 0,
      dimensionLength: 0,
      grossWeight: 0,
      netWeight: 0,
      weightUnitOfMeasureId: "",
      volumeUnitOfMeasureId: "",
      volume: 0,
      dimensionUnitOfMeasureId: "",
      businessPartnerId: null,
      companyId: null,
      isOwn: false,
      color: "",
      model: ""
    };
  }

  //start filter
  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      }
    });
  }

  private getAllBusinessPartner(): void {
    let filter: IFilters = {}

    const materialOptions = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService.findAllWithCount(
      materialOptions,
      false,
      [],
      'both',
      filter // agregar filter 
    ).subscribe({
      next: (res: IPaginationResult<BusinessPartnerAttributes>) => {
        this.businessPartnerList = res?.data?.[0]?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al traer registros', 'Cerrar', { duration: 3000 });
      },
    })
  }

  changueOptionsBusiness(event) {
    this.searchSubjectBusiness.next(event)
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }

  fetchReasonVehicleTypes() {
    this.vehicleTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.reasonVehicleTypeList = res.data;
        this.filteredReasonVehicleTypeList = this.reasonVehicleTypeList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.", "Cerrar", { duration: 3000 }
        );
      },
    });
  }

  changueOptionVehicle(event) {
    if (!this.reasonVehicleTypeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filteredReasonVehicleTypeList = this.reasonVehicleTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredReasonVehicleTypeList = this.reasonVehicleTypeList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }
  //end Filter

  //#region Service Form
  getUnitMeasureByGroup(group: UnitMeasurementGroupEnum): void {
    const options = {
      search: this.searchByGroup[group] || null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
    };

    this.unitMeasureService.findToComboBoxPagination(options, group).subscribe({
      next: (res: IRequestResult<UnitMeasurementsAttributes[]>) => {
        this.unitMeasurementsByGroup[group] = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error?.message || 'Error al traer registros', 'Cerrar', { duration: 3000 });
      },
    });
  }

  private setupUnitMeasurementSearchControl(): void {
    Object.entries(this.searchSubjects).forEach(([group, subject]) => {
      subject.pipe(
        debounceTime(700),
        distinctUntilChanged()
      ).subscribe((searchTerm) => {
        if (searchTerm !== undefined) {
          this.searchByGroup[group as UnitMeasurementGroupEnum] = searchTerm;
          this.getUnitMeasureByGroup(group as UnitMeasurementGroupEnum);
        }
      });
    });
  }

  loadAllUnitMeasurements(): void {
    Object.values(UnitMeasurementGroupEnum).forEach(group => {
      this.getUnitMeasureByGroup(group);
    });
  }
  // #endregion

  openModal(vehicle?: VehicleAttributes): void {
    if (vehicle) {
      this.searchBusiness = vehicle.businessPartner ? vehicle.businessPartner.name : null
    }

    this.getAllCompanies()
    this.getAllBusinessPartner()
    this.setupBusinessSearchControl()
    this.fetchReasonVehicleTypes()
    this.loadAllUnitMeasurements()
    this.setupUnitMeasurementSearchControl()

    if (vehicle) {
      this.currentVechicle = {
        ...vehicle,
        code: vehicle.code, //no debo mandar
        externalKey: this.getCode(vehicle) ? this.getCode(vehicle) : null,
        companyId: vehicle.company ? vehicle.company._id.toString() : "",
        businessPartnerId: vehicle.businessPartner ? vehicle.businessPartner._id.toString() : null,
        typeId: vehicle.type ? vehicle.type._id.toString() : "",
        dimensionHeight: vehicle.dimensions?.height ?? 0,
        dimensionWidth: vehicle.dimensions?.width ?? 0,
        dimensionLength: vehicle.dimensions?.length ?? 0,
        grossWeight: vehicle.dimensions?.grossWeight ?? 0,
        netWeight: vehicle.dimensions?.netWeight ?? 0,
        weightUnitOfMeasureId: vehicle.dimensions?.weightUnitOfMeasure?._id.toString() ?? "",
        volume: vehicle.dimensions?.volume ?? 0,
        volumeUnitOfMeasureId: vehicle.dimensions?.volumeUnitOfMeasure?._id.toString() ?? "",
        dimensionUnitOfMeasureId: vehicle.dimensions.dimensionUnitOfMeasure?._id.toString() ?? "",
        color: vehicle.color,
        model: vehicle.model
      };
      this.id = vehicle._id
    } else {
      this.currentVechicle = this.initializeCreateVehicle();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit() {
    if (this.id == null) {
      this.createVehicle()
    } else {
      this.updateVehicle(this.id)
    }
  }

  onChange(isOwn: string) {
    if (isOwn) {
      this.currentVechicle.businessPartnerId = null;
    }
  }

  createVehicle(): void {
    const dataToSend: any = Object.entries(this.currentVechicle)
      .reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && !(Array.isArray(value) && value.length === 0)) {
          acc[key] = value;
        }
        return acc;
      }, {});

    this.vechicleService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateVehicle(id: string): void {
    if (this.currentVechicle) {
      const updatedVehicle: IUpdateVehicle = {
        name: this.currentVechicle.name,
        typeId: this.currentVechicle.typeId ?? null,
        plate: this.currentVechicle.plate,
        brand: this.currentVechicle.brand,
        description: this.currentVechicle.description,
        businessPartnerId: this.currentVechicle.businessPartnerId ?? undefined,
        companyId: this.currentVechicle.companyId ?? null,
        dimensionHeight: this.currentVechicle.dimensionHeight ?? 0,
        dimensionWidth: this.currentVechicle.dimensionWidth ?? 0,
        dimensionLength: this.currentVechicle.dimensionLength ?? 0,
        grossWeight: this.currentVechicle.grossWeight ?? 0,
        netWeight: this.currentVechicle.netWeight ?? 0,
        volume: this.currentVechicle.volume ?? 0,
        dimensionUnitOfMeasureId: this.currentVechicle.dimensionUnitOfMeasureId ?? "",
        volumeUnitOfMeasureId: this.currentVechicle.volumeUnitOfMeasureId ?? "",
        weightUnitOfMeasureId: this.currentVechicle.weightUnitOfMeasureId ?? "",
        color: this.currentVechicle.color,
        model: this.currentVechicle.model
      };

      this.vechicleService.update(id, updatedVehicle).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if (this.dialogRef) {
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, vehicle: VehicleAttributes): void {
    const originalStatusId = vehicle.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedVehicle = {
      ...vehicle,
      statusId: updatedStatusId
    };

    this.vechicleService.update(vehicle._id.toString(), updatedVehicle).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        vehicle.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(vehicle: VehicleAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: vehicle, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(vehicle._id.toString()));
  }

  delete(id: string): void {
    this.vechicleService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  onExportButtonPressed() {
    if (!this.vehicleExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: VEHICLE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.vehicleExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
